import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function EventDetails({ card, onClose }) {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set autoplay speed in milliseconds (e.g., 3000ms = 3 seconds)
  };

  // Format date and time
  const eventDate = new Date(card.date);
  const formattedDate = eventDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC", // 👈 Optional: show date in UTC too
  });
  
  const formattedTime = eventDate.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC", // 👈 Add this line to force UTC time
  });
  

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="relative bg-white p-8 rounded-lg shadow-lg max-w-5xl w-full">
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-1 right-2 text-4xl text-gray-500 hover:text-red-600"
        >
          <IoIosCloseCircleOutline />
        </button>

        {/* Content Section */}
        <div className="flex flex-row space-x-6">
          {/* Text Content */}
          <div className="w-2/3">
            <h2 className="text-4xl font-bold text-gray-800 mb-6 font-titillium">
              {card.title}
            </h2>
            <div
              className="text-gray-600 leading-relaxed text-justify overflow-y-auto font-inter"
              style={{ maxHeight: "200px" }} // Adjust the height as needed
            >
              {card.description}
            </div>

            {/* Subsections */}
            <div className="mt-6 gap-4 text-left">
              <div>
                <h3 className="text-black mb-2">
                  <span className="text-primary-color">Date : </span>
                  <span className="font-inter"> {formattedDate}</span>
                </h3>

                <h3 className="text-black mb-2">
                  <span className="text-primary-color">Time : </span>
                 <span className="font-inter">{formattedTime}</span>
                </h3>

                <h3 className="text-black mb-2">
                  <span className="text-primary-color">Location : </span>
                  <span className="font-inter">{card.location}</span>
                </h3>
              </div>
            </div>
          </div>

          {/* Image Carousel */}
          <div className="w-1/2 flex justify-end">
            <div className="w-full">
              {card.files.length > 1 ? (
                <Slider {...sliderSettings}>
                  {card.files.map((files, index) => (
                    <div key={index} className="w-full">
                      <img
                        src={files}
                        alt={card.title}
                        className="w-full h-[300px] object-contain rounded-lg"
                      />
                    </div>
                  ))}
                </Slider>
              ) : (
                <img
                  src={card.files[0]}
                  alt={card.title}
                  className="w-full h-[300px] object-contain rounded-lg"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventDetails;